export enum MimeTypes {
  pdf = "application/pdf",
  png = "image/png",
  svg = "image/svg+xml",
  tif = "image/tiff",
  webp = "image/webp",
  jpeg = "image/jpeg",
  zip = "application/zip",
  x7z = "application/x-7z-compressed",
  rar = "application/vnd.rar",
  excel = "application/vnd.ms-excel",
  xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml",
  doc = "application/msword",
  docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  zipCompressed = "application/x-zip-compressed"
}
